var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ChevronDownSmallIcon } from '@inter-ikea-kompis/icons';
import { SafariWriteDirectionUtility } from '@inter-ikea-kompis/utilities';
import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';
import QuantityStyle from './QuantityStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * @event change Emits when the quantity value changes
 */
export default class Quantity extends KompisElement {
    constructor() {
        super(...arguments);
        // Set the select to disabled state.
        this.disabled = false;
        // Minimum selectable value.
        this.min = 0;
        // Maximum selectable value.
        this.max = 100;
        // Set the value of the field.
        this.value = 0;
        this.hasFocus = false;
        this.pointerIsDown = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const direction = SafariWriteDirectionUtility.getWriteDirection(this);
        const values = [];
        for (let i = this.min; i <= this.max; i++) {
            values.push(i);
        }
        return html `
			<style>
				${QuantityStyle.getStyle({
            isDisabled: this.disabled,
            hasFocus: this.hasFocus,
            direction: direction,
            max: this.max,
            theme: this.theme
        })}
			</style>
			<div class="container">
				<div class="dropdown">
					<div class="outline"></div>
					<select
						@change="${this.onChange.bind(this)}"
						.disabled="${this.disabled}"
						@pointerdown="${this.onPointerDown.bind(this)}"
						@focusout="${this.onFocusOut.bind(this)}"
						@focus="${this.onFocus.bind(this)}"
						tabindex="0"
					>
						${values.map((value) => html `<option ?selected="${value === this.value}">${value}</option>`)}
					</select>
					${this.getChevronIcon()}
				</div>
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-icon', Icon);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * Runs when change event occurs.
     *
     * @param event HTMLEvent.
     */
    onChange(event) {
        const target = event.target;
        const value = Number(target.value);
        this.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: {
                value
            }
        }));
    }
    /**
     * Gets the chevron icon.
     *
     * @returns Template.
     */
    getChevronIcon() {
        return html `
			<kompis-icon .theme="${this.theme}" .icon="${ChevronDownSmallIcon}"></kompis-icon>
		`;
    }
    /**
     * HTML event handler.
     */
    onFocusOut() {
        this.hasFocus = false;
        this.pointerIsDown = false;
        this.update();
    }
    /**
     * HTML event handler.
     */
    onFocus() {
        if (this.pointerIsDown) {
            return;
        }
        this.hasFocus = true;
        this.update();
    }
    /**
     * HTML event handler.
     */
    onPointerDown() {
        this.pointerIsDown = true;
        if (this.hasFocus) {
            this.hasFocus = false;
            this.update();
        }
    }
}
__decorate([
    property({ type: Boolean })
], Quantity.prototype, "disabled", void 0);
__decorate([
    property({ type: Number })
], Quantity.prototype, "min", void 0);
__decorate([
    property({ type: Number })
], Quantity.prototype, "max", void 0);
__decorate([
    property({ type: Number })
], Quantity.prototype, "value", void 0);
__decorate([
    property({ type: Object, required: true })
], Quantity.prototype, "theme", void 0);
//# sourceMappingURL=Quantity.js.map